<template>
    <b-card no-body>
        <template #header>
            <strong>User Administration</strong>
        </template>

        <div class="p-1">
            <b-tabs ref="administrationTabs" v-if="has_mounted" justified nav-class="nav-tabs-custom" content-class="p-3 text-muted">
                <b-tab lazy active>
                    <template v-slot:title>
                        <span class="d-none d-sm-inline-block">Users Table</span>
                    </template>
                    <Table @level_id="setID" :selected_level_id="selected_level_id"/>
                </b-tab>
                <b-tab lazy>
                    <template v-slot:title>
                        <span class="d-none d-sm-inline-block">Organogram</span>
                    </template>
                    <LevelsOrgChart @level_id="setID"/>
                </b-tab>
            </b-tabs>

            <b-alert v-else show > 
                <h5>Loading Data</h5>
            </b-alert>
        </div>
    </b-card>
</template>

<script>
import Table from './components/clientUsersTable.vue'
import LevelsOrgChart from './components/levelOrgChart.vue'
import { clientAdminState, clientAdminMethods } from '@/state/helpers'
export default {
    data:() => ({
        has_mounted: false,
        selected_level_id: null,
    }),
    components:{
        Table,
        LevelsOrgChart
    },
    computed:{
        ...clientAdminState,
    },
    methods:{
        ...clientAdminMethods,
        setID(id){
            this.selected_level_id = id;
            this.$refs.administrationTabs.previousTab();
        }
    },
    mounted(){
        if(this.user_levels == null){
            this.loadLevels()
            .then(()=>{
                this.has_mounted = true;
            })
        }
        else{
            this.has_mounted = true;
        }
    },
}
</script>

<style>

</style>